<template>
<div class="menu">
  <v-container style='margin-top: 5%; margin-bottom: 5%'>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols='12' sm='8' md='6' lg='4'>
        <v-img
          :src="myImage"
          width='100%'>
        </v-img>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols='12' sm='8' md='6' lg='4' align='center'>
        <v-btn class="button" color="primary" @click="goTo('Contrato')">
          Contratos <i class="mdi mdi-file-document"></i>
        </v-btn>
        <v-btn class="button" color="primary" @click="goTo('Contactos')">
          Contactos <i class="mdi mdi-account-multiple"></i>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  export default {
    data () {
      return {
        myImage: require('@/assets/firmatyaCuadrado.png'),
        user: {},
      }
    },
    methods:{
      ...mapGetters(['getClient']),
      ...mapActions(['setClient']),
      goTo(name) {
        this.$router.push({name});
      },
      getCliente(){
        this.user = this.getClient();
      },
    }
  };
</script>
<style>
.menu{
  z-index: 0;
}
.button{
  margin: 5px 0px 5px 20px;
}
</style>